<template>
  <SUserLayout
    sidebarTitle="settings.title"
    sidebarIcon="mdi-cog"
    :sidebarItems="items"
  >
    <div class="setting-page-container__content d-flex justify-content-center">
      <RouterView />
    </div>
  </SUserLayout>
</template>

<script lang="ts">
export default {
  name: 'SettingsPage',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import { useI18n } from '@/composables';

const { t } = useI18n();

const items = computed(() => [
  {
    name: t('settings.profile'),
    route: 'profile',
  },
  {
    name: t('settings.security'),
    route: 'security',
  },
]);
</script>
